// The purchase flow is served from a "pay." subdomain of the same app
// (pay.prepaidmeter.ng in production, pay.localhost in development).
const PAY_PREFIX = "pay.";

export const isPayHost = () => window.location.hostname.toLowerCase().startsWith(PAY_PREFIX);

// Absolute URL on the main site (the host without the "pay." prefix).
export const mainSiteUrl = (path = "/") => {
  const { protocol, hostname, port } = window.location;
  const host = hostname.toLowerCase().startsWith(PAY_PREFIX) ? hostname.slice(PAY_PREFIX.length) : hostname;
  return `${protocol}//${host}${port ? `:${port}` : ""}${path}`;
};
